import { AtLinkButton, AtLinkButtonProps } from '../../atoms'
import { getAtImageVariant } from '../../atoms/at-image/at-image.props'
import { Media, OrMedia } from '../../organisms'
import { cn } from '../../utils/cn'

type MLBannerImageHeadingCtaOrientation = 'image-left' | 'image-right'

export interface MLBannerImageHeadingCtaProps {
  name?: string
  headline?: string
  description?: string
  media?: Media
  cta?: AtLinkButtonProps
  orientation?: MLBannerImageHeadingCtaOrientation
}

export const MLBannerImageHeadingCta = ({
  media,
  headline,
  description,
  cta,
  orientation = 'image-right',
}: MLBannerImageHeadingCtaProps) => {
  const hasMedia = Boolean(media && media.src)
  const hasLink = Boolean(cta && cta.title && cta.actionTarget && cta.target)

  if (!hasMedia && !hasLink) return null

  return (
    <div
      className={cn(
        'flex flex-col-reverse space-y-10.5 space-y-reverse',
        orientation === 'image-left' && 'md:flex-row-reverse md:space-x-reverse',
        orientation === 'image-right' && 'md:flex-row',
        'md:space-x-20 md:space-y-0 items-center justify-center md:py-17.75 py-8 px-8 lg:px-17 md:flex-row md:h-170'
      )}
    >
      <div className="flex flex-col justify-center h-full w-full lg:w-auto lg:flex-1 text-neutrals-900 md:space-y-8 space-y-10.5">
        <div className="md:p-2.5 space-y-6">
          {headline && (
            <h2 className="md:text-56 text-40 font-medium md:leading-16.75 leading-12 font-heading">{headline}</h2>
          )}
          {description && <p className="md:text-24 text-16 font-regular md:leading-9 leading-6">{description}</p>}
        </div>
        {hasLink && (
          <div className="w-full md:p-2.5">
            <AtLinkButton
              variant="button-primary-light"
              title={cta?.title}
              actionTarget={cta?.actionTarget}
              target={cta?.target}
              parentName="MlBannerImageHeadingCta"
            ></AtLinkButton>
          </div>
        )}
      </div>
      {hasMedia && (
        <div className="flex h-full w-full lg:w-[720px] lg:shrink-0">
          {media && <OrMedia {...media} className={getAtImageVariant('cover')} />}
        </div>
      )}
    </div>
  )
}
